import { render } from "./ArenaSlidesBlock.vue?vue&type=template&id=2cd9b726&scoped=true"
import script from "./ArenaSlidesBlock.vue?vue&type=script&lang=js"
export * from "./ArenaSlidesBlock.vue?vue&type=script&lang=js"

import "./ArenaSlidesBlock.vue?vue&type=style&index=0&id=2cd9b726&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cd9b726"
/* hot reload */
if (module.hot) {
  script.__hmrId = "2cd9b726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd9b726', script)) {
    api.reload('2cd9b726', script)
  }
  
  module.hot.accept("./ArenaSlidesBlock.vue?vue&type=template&id=2cd9b726&scoped=true", () => {
    api.rerender('2cd9b726', render)
  })

}

script.__file = "src/components/blocks/ArenaSlidesBlock.vue"

export default script